
import CloseIcon from '~/components/ui/icons/CloseIcon.vue';
export default {
  name: 'UISimpleProfileCard',
  components: { CloseIcon },
  props: {
    ticker: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
